"use strict";
// packages/contracts/src/vendas-importacao.ts — Fase 12, Plano 08 (PV-03, D-30, D-31, D-32).
// Contrato da importacao de planilha do pedido de compra do cliente (ler -> previa -> confirmar).
// A confirmacao REPROCESSA o arquivo no servidor: o navegador so envia arquivo + mapeamento + flags (T-12-27).
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAMPOS_OBRIGATORIOS_IMPORTACAO_PV = exports.CAMPOS_IMPORTACAO_PV = void 0;
exports.CAMPOS_IMPORTACAO_PV = ['numeroPedido', 'codigoItemCliente', 'descricao', 'cor', 'quantidade', 'unidade', 'preco', 'prazo'];
/** Campos que o mapeamento precisa ter para gerar a previa. */
exports.CAMPOS_OBRIGATORIOS_IMPORTACAO_PV = ['codigoItemCliente', 'quantidade'];
//# sourceMappingURL=vendas-importacao.js.map